var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-tiptap-action-bar-dropdown.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/chemistry/elements/components/x-vr.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ActionbarDropdown } from "./actionbarElements.js";
var XTiptapActionBarDropdown = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.dropdown = null;
    this._open = false;
    this._translator = new TranslationController(this);
  }
  styles() {
    return [
      ...super.styles(),
      {
        ".dropdown": {
          position: "absolute",
          top: `calc(100% + ${this.spacing.sm})`,
          left: "0",
          background: this.colors.neutral.shade(50),
          border: `1px solid ${this.colors.neutral.shade(100)}`,
          borderRadius: "4px"
        },
        ".elem": {
          cursor: "pointer",
          color: this.colors.neutral,
          fontSize: "20px",
          "&:hover": {
            background: this.colors.white
          }
        },
        ".toolbar-button": {
          fontSize: "24px",
          borderRadius: "4px",
          padding: "2px",
          color: this.colors.neutral
        },
        ".toolbar-button:hover": {
          background: this.colors.neutral.shade(50)
        }
      }
    ];
  }
  render() {
    if (!this.dropdown) {
      return nothing;
    }
    return html`
      <x-flex ${css({ position: "relative" })}>
        <x-flex
          horizontal
          class="toolbar-button"
          @click=${() => {
      this._open = !this._open;
    }}
        >
          <x-icon> ${this.dropdown.icon} </x-icon>
          <x-icon> ${this._open ? "arrow_drop_up" : "arrow_drop_down"} </x-icon>
          ${this.dropdown.tooltip ? html`
                <x-tooltip .text=${html` <x-text> ${this._translator.translate(this.dropdown.tooltip)} </x-text> `}>
                </x-tooltip>
              ` : nothing}
        </x-flex>
        ${this._open ? html`
              <x-grid columns="max-content" class="dropdown">
                ${this.dropdown.items.map((item) => {
      if (item instanceof ActionbarDropdown) {
        return nothing;
      }
      return html`
                    <x-flex
                      class="elem"
                      space="xs"
                      padding="xs"
                      horizontal
                      crossaxis-center
                      @click=${() => {
        item.action?.();
        this._open = false;
      }}
                    >
                      <x-flex ${css({ width: "20px" })} crossaxis-center>
                        <x-icon ${css({ color: item.color ? item.color : "", background: item.background ?? "unset" })}>
                          ${item.icon}
                        </x-icon>
                      </x-flex>
                      <x-text> ${item.dropdownText ?? item.tooltip ?? ""} </x-text>
                    </x-flex>
                  `;
    })}
              </x-grid>
            ` : nothing}
      </x-flex>
    `;
  }
};
__decorateClass([
  property({ attribute: false })
], XTiptapActionBarDropdown.prototype, "dropdown", 2);
__decorateClass([
  state()
], XTiptapActionBarDropdown.prototype, "_open", 2);
XTiptapActionBarDropdown = __decorateClass([
  customElement("x-tiptap-action-bar-dropdown")
], XTiptapActionBarDropdown);
export {
  XTiptapActionBarDropdown
};
